export const credentials = {
  title: 'Credenziali e Pubblicazioni',
  sections: [
    {
      id: 'education-certifications',
      title: '🎓 Formazione e Abilitazioni',
      type: 'list',
      items: [
        'Psicologo iscritto all\'Ordine degli Psicologi della Lombardia (n° 25621)',
        'Laurea Magistrale a pieni voti in Psicologia Clinica',
        'Specializzazione con lode in Psicoterapia Cognitivo Comportamentale',
        'In formazione avanzata in Sessuologia Clinica'
      ],
      metadata: {
        category: 'education',
        order: 1
      }
    },
    {
      id: 'publications',
      title: '📚 Pubblicazioni Scientifiche Internazionali',
      type: 'publications',
      items: [
        {
          title: 'For a Theory of the Psychotherapeutic Process: Epistemology of Recursion and Relational Fractality',
          journal: 'Nonlinear Dynamics, Psychology and Life Sciences',
          year: 2024,
          url: 'https://pubmed.ncbi.nlm.nih.gov/39356472/'
        },
        {
          title: 'Relational Fractal Dimension. From the Complexity of the Psychological Interview to the Emergence of the Therapeutic Relationship',
          journal: 'Nonlinear Dynamics, Psychology and Life Sciences',
          year: 2022,
          url: 'https://pubmed.ncbi.nlm.nih.gov/34973161/'
        }
      ],
      metadata: {
        category: 'research',
        order: 2
      }
    },
    {
      id: 'academic-profile',
      title: '🔬 Profilo Accademico',
      type: 'links',
      items: [
        {
          title: 'ResearchGate',
          url: 'https://www.researchgate.net/profile/Jacopo-Biraschi',
          description: 'Segui i miei contributi alla ricerca scientifica e le pubblicazioni in corso sulla Relational Fractal Dimension'
        }
      ],
      metadata: {
        category: 'academic',
        order: 3
      }
    },
    {
      id: 'conferences',
      title: '🎯 Relatore in Congressi Nazionali e Internazionali',
      type: 'conferences',
      items: [
        {
          id: 'athens-2024',
          dates: '27-30 maggio 2024',
          title: '18th International Conference on Psychology, Athens, Greece',
          content: [
            {
              type: 'abstract',
              text: 'The Psychotherapy Session as a Fractal Process: A New Conception of the Therapeutic Relationship'
            }
          ],
          image: 'conference-1',
          metadata: {
            year: 2024,
            location: 'Athens, Greece'
          }
        },
        {
          id: 'cbt-italia-2022',
          dates: '03-04 novembre 2022',
          title: 'Primo Congresso Nazionale CBT-Italia',
          content: [
            {
              type: 'organizer',
              text: 'Organizzato da: Società Italiana di Psicoterapia Cognitivo Comportamentale'
            },
            {
              type: 'context',
              text: 'Simposio 34: Nuove frontiere della terapia cognitivo comportamentale'
            },
            {
              type: 'presentation',
              text: 'Complessità della relazione terapeutica e sua misurazione: il concetto di Dimensione Frattale Relazionale'
            },
            {
              type: 'location',
              text: 'Firenze, Hilton Hotel'
            }
          ],
          image: 'conference-2',
          metadata: {
            year: 2022,
            location: 'Florence, Italy'
          }
        },
        {
          id: 'chaos-theory-2021',
          dates: '23 luglio 2021',
          title: '31st International Conference of the Society for Chaos theory in Psychology & Life Sciences',
          content: [
            {
              type: 'presenter',
              text: 'Jacopo Biraschi, Independent Scholar'
            },
            {
              type: 'presentation',
              text: 'Relational Fractal Dimension. From the complexity of the psychological interview to the emergence of the therapeutic relationship'
            },
          ],
          image: 'conference-3',
          metadata: {
            year: 2021,
            format: 'virtual'
          }
        },
        {
          id: 'forum-psicoterapia-2019',
          dates: '12 ottobre 2019',
          title: 'VIII Forum sulla Formazione in Psicoterapia',
          content: [
            {
              type: 'organizer',
              text: 'Organizzato da: Scuole di Specializzazione in Psicoterapia Cognitiva (APC, SPC, AIPC, IGB, SICC)'
            },
            {
              type: 'presentation',
              text: 'Dipendenza Affettiva Patologica: utilità del costrutto, stato dell\'arte e prospettive future'
            },
            {
              type: 'location',
              text: 'Assisi (PG), Cittadella Ospitalità, via degli Ancajani 3'
            }
          ],
          metadata: {
            year: 2019,
            location: 'Assisi, Italy'
          }
        }
      ],
      metadata: {
        category: 'conferences',
        order: 4
      }
    },
    {
      id: 'affiliations',
      title: '🤝 Affiliazioni Professionali',
      type: 'list',
      items: [
        'Membro della Society for Chaos Theory in Psychology & Life Sciences (dal 2021)',
        'Membro della Società Italiana di Psicoterapia Cognitivo Comportamentale (dal 2024)'
      ],
      metadata: {
        category: 'memberships',
        order: 5
      }
    }
  ]
};
